


































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* 以下画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { ScreenMode } from '../../CommonUtils/fixed/ScreenMode';
import { organizationModule } from '../store/modules/Organization'; // ストアモジュール
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { IOrg, ITree } from '../store/dto/Organization'; // dto
import { routingControlModule } from '@/store/modules/RoutingControl';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
import { KnariScreenName } from '../fixed/KanriScreenName';
import { KanriConstants } from '../fixed/KanriConstants';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class OrganizationSearch extends ApiAccessBase {
  private treeKey = 0;
  private treeValue: ITree = {szkCd: '', naibCd: '', level: '', position: ''};
  // 拡張パネルの設定（検索条件）
  private searchPanel: number[] = [0];  //初期表示展開
  // ページネーション部品の初期値設定
  private page = 1;  // 初めに表示するページの番号（基本的に1で固定）
  private itemPerPage = 10; // 1ページあたりに表示するレコードの数
  private pageCount =  0; // ページカウントの初期化(0固定)
  // 検索結果ヘッダの設定
  private headers = [
    {
      text: '削除',
      align: 'center',
      sortable: false,
      value: 'delete',
      width: 120,
    },
    {
      text: '組織/内部組織コード',
      align: 'center',
      sortable: true,
      value: 'searchCd',
    },
    {
      text: '有効期間',
      align: 'center',
      sortable: true,
      value: 'searchKikan',
    },
    {
      text: '組織/内部組織名称',
      align: 'center',
      sortable: true,
      value: 'searchName',
    },
  ];
  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = '組織一覧';
    routingControlModule.registCurrent(this.$route.name);
    routingControlModule.registPrevious(KnariScreenName.ORGANIZATION_MENU);
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['organization_search', 'group_test']);
    const path: string = KanriConstants.ORG_PATH + '/init/search';
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
            // 再検索
            if (organizationModule.CHECK_RE_SEARCH) {
              this.formData = organizationModule.GET_FORM_DATA;
              this.syncFormDataToVariableCols();
              this.searchOrg();
            }
      }
    });

  }
  /**
   * ツリー情報の監視
   * deep: true(ネストされたプロパティも監視する)
   */
  @Watch('treeValue', {deep: true})
  private updateTreeValue(newValue: ITree, oldValue: ITree) {
    this.formData['parentSzkCd'] = newValue.szkCd;
    this.formData['parentNaibCd'] = newValue.naibCd;
  }
  /**
   * 登録画面への遷移
   * (新規追加ボタン押下時時に発火)
   */
  private moveInfo() {
    routingControlModule.leaveCurrent();
    router.push({ name: 'organizationInfo' });
  }

  /**
   * 組織情報の削除
   * @param szkcd 所属コード
   * @param naibcd 内部組織コード
   * @param kanrino 管理番号
   * (表削除列_削除アイコン押下時に発火)
   */
  private deleteOrg(param: IOrg) {
    if (window.confirm(Message.I0001)) {
      organizationModule.setOrg(param);
      // APIアクセス
      this.apiAccess(
        KanriConstants.ORG_PATH + '/delete' + organizationModule.GET_PATH
           , Constants.API_METHOD_POST, false, null)
      .then((result) => {
        this.hrefElement('organizationSearch', -50);
        if (result === Constants.API_RESULT_SUCCES) {
          // 結果から削除したデータを削除
          for (const rowIndex of Object.keys(this.resultData)) {
            if (this.resultData[Number(rowIndex)]['szkCd'] === param.szkCd
            && this.resultData[Number(rowIndex)]['naibCd'] === param.naibCd
            && this.resultData[Number(rowIndex)]['kanriNo'] === param.kanriNo) {
              this.resultData.splice(Number(rowIndex), 1);
              this.treeKey = this.treeKey ? 0 : 1;
            }
          }
        } else {
        }
      });
    }
  }
  /**
   * 組織情報の編集
   * @param szkcd 所属コード
   * @param naibcd 内部組織コード
   * @param kanrino 管理番号
   * (組織/内部組織コード列_編集アイコン押下時に発火)
   */
  private dataTransferInfo(param: IOrg) {
    organizationModule.setOrg(param);
    this.apiAccess(KanriConstants.ORG_PATH + organizationModule.GET_EXCLUSIVE_PATH, Constants.API_METHOD_POST, false, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        organizationModule.transferToInfo();
        routingControlModule.leaveCurrent();
        router.push({ name: 'organizationInfo' });
      } else {
        organizationModule.moduleSelectReset();
        this.hrefElement('organizationSearch', -50);
      }
    });
  }
  /**
   * 組織情報の検索
   * (検索ボタン押下時に発火)
   */
  private searchOrg() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    this.apiAccess(KanriConstants.ORG_PATH, Constants.API_METHOD_POST, true, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        organizationModule.setFormData(this.formData);
        // 検索一覧の先頭へジャンプ
        this.hrefElement('searchResults', -50);
      } else {
        // TOPへジャンプ
        this.hrefElement('organizationSearch', -50);
      }
    });
  }

  /**
   * 「戻る」イベント
   * 遷移元の画面に戻る
   */
  private returnPrevious() {
    organizationModule.moduleReset();
    router.push({ name: 'organizationMenu' });
    // router.push(routingControlModule.GET_PREVIOUS);
  }
}
